@if (showActionMenu) {
    <div class="image-action-menu-general" (click)="$event.stopPropagation()">
        <div class="d-flex gap-2 px-2">
            @if (hasSwap) {
                <lib-button
                    qaTag="image-action-menu-arrow-back-icon-button"
                    [kind]="ButtonKind.NeutralTertiary"
                    [prefixIcon]="Icon.Common.ArrowBack"
                    [disabled]="swapDisabled"
                    [iconOnly]="true"
                    (clicked)="ImageActionClicked(WebsiteBlockImageAction.MoveLeft)">
                </lib-button>
                <lib-button
                    qaTag="image-action-menu-arrow-forward-icon-button"
                    [kind]="ButtonKind.NeutralTertiary"
                    [prefixIcon]="Icon.Common.ArrowForward"
                    [disabled]="swapDisabled"
                    [iconOnly]="true"
                    (clicked)="ImageActionClicked(WebsiteBlockImageAction.MoveRight)">
                </lib-button>
            }
            <lib-button
                qaTag="image-action-menu-cloud-upload-icon-button"
                [kind]="ButtonKind.NeutralTertiary"
                [prefixIcon]="Icon.Common.CloudUploadOutline"
                [iconOnly]="true"
                (clicked)="ImageActionClicked(WebsiteBlockImageAction.MediaGallery)">
            </lib-button>
            @if (hasDetails) {
                <lib-button
                    qaTag="image-action-menu-info-icon-button"
                    [kind]="ButtonKind.NeutralTertiary"
                    [prefixIcon]="Icon.Common.InfoOutline"
                    [iconOnly]="true"
                    (clicked)="ImageActionClicked(WebsiteBlockImageAction.Details)">
                </lib-button>
            }
            @if (!noDelete) {
                <lib-button
                    qaTag="image-action-menu-delete-icon-button"
                    [kind]="ButtonKind.DangerTertiary"
                    [prefixIcon]="Icon.Common.DeleteOutline"
                    [disabled]="deleteDisabled"
                    [iconOnly]="true"
                    (clicked)="ImageActionClicked(WebsiteBlockImageAction.Delete)">
                </lib-button>
            }
        </div>
    </div>
}